import ScrollToTopOnMount from "../../components/ScrollToTopOnMount/ScrollToTopOnMount";
import ItemDetails from "../../layouts/ItemDetails/ItemDetails";


const ItemDetailsPage = () => {
    return (
        <>
            <ScrollToTopOnMount />
            <ItemDetails />
        </>
        
    )
}

export default ItemDetailsPage;